import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersistence from 'vuex-persist';
import { EBiennial } from '@/store/modules/ebiennial';


Vue.use(Vuex);


const vuexPersist = new VuexPersistence({
  strictMode: true,
  storage: window.localStorage,
});

export default new Vuex.Store<any>({
  modules: {
    ebiennial: EBiennial,
},
  state: {

  },
  mutations: {
    RESTORE_MUTATION: vuexPersist.RESTORE_MUTATION,
  },
  actions: {

  },
  plugins: [vuexPersist.plugin],
    strict: true,
});
